import { PILL_COLORS } from "components/ui/Pill/pillColors";

// Maps MncmsOutboundDisplayStatus (derived BE badge) → label + pill colours.
// AWAITING_ACK / NO_ACK mean the message was NOT confirmed delivered, so they
// are surfaced as non-success (never silently treated as sent).
export const MNCMS_OUTBOUND_STATUS = {
  ACCEPTED: { label: "Accepted", ...PILL_COLORS.statusSuccess },
  AWAITING_ACK: { label: "Awaiting ACK", ...PILL_COLORS.statusWarning },
  NO_ACK: { label: "No ACK", ...PILL_COLORS.statusError },
  REJECTED: { label: "Rejected", ...PILL_COLORS.statusError },
  ERROR: { label: "Error", ...PILL_COLORS.statusError },
};

export const getMncmsOutboundStatus = (displayStatus) =>
  MNCMS_OUTBOUND_STATUS[displayStatus] ?? {
    label: displayStatus || "-",
    ...PILL_COLORS.statusNoStatus,
  };
